import { Stack, Title, Alert, Text, Anchor } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";

export const WebhookLogs = () => {
  return (
    <Stack gap="md">
      <Title>Webhook Logs</Title>
      <Alert
        icon={<IconInfoCircle />}
        color="blue"
        title="Migrating to the unified Journal"
      >
        <Text size="sm">
          Webhook delivery logs are being moved into the platform's new
          unified <strong>Journal</strong> system, alongside tournament
          rule executions, system events, and audit entries. The new
          interface offers richer filtering (by primary resource,
          severity, time range), live tail via GraphQL subscription, and
          stronger payload typing.
        </Text>
        <Text size="sm" mt="xs">
          Webhook deliveries will appear here once the webhook emitter
          migration to <Anchor href="/developer/docs">the Journal API</Anchor>
          is complete. In the meantime, the legacy log table has been
          retired.
        </Text>
      </Alert>
    </Stack>
  );
};
